export const LOAD_BOXES = 'LOAD_BOXES';
export const SET_BOX_PAGINATION = 'SET_BOX_PAGINATION';
export const SET_BOX_FILTERS = 'SET_BOX_FILTERS';
export const ADD_BOX = 'ADD_BOX';
export const LOAD_EDITABLE_BOX = 'LOAD_EDITABLE_BOX';
export const EDIT_BOX = 'EDIT_BOX';
export const SET_EMPTY_EDITABLE_BOX = 'SET_EMPTY_EDITABLE_BOX';
